import {
    DefaultAuditLogCategoryQueryParams,
    DefaultAuditLogCategorySortParams,
    DefaultAuditLogEntryQueryParams,
    DefaultAuditLogEntrySortParams,
    DefaultCallBackQueryParams,
    DefaultCallBackSortParams,
    DefaultCaseQueryParams,
    DefaultCaseSortParams,
    DefaultFormQueryParams,
    DefaultFormSortParams,
    DefaultFormDataQueryParams,
    DefaultFormDataSortParams,
    DefaultFormSelectCategoryQueryParams,
    DefaultFormSelectCategorySortParams,
    DefaultFormSelectQueryParams,
    DefaultFormSelectSortParams,
    DefaultPageParams,
    DefaultTenantQueryParams,
    DefaultTenantSortParams,
    DefaultUserQueryParams,
    DefaultUserSortParams,
    IParams,
    DefaultFormCategorySortParams,
    DefaultFormCategoryQueryParams,
    DefaultCaseFileCategorySortParams,
    DefaultCaseFileCategoryQueryParams,
    DefaultFormDataArchiveSortParams,
    DefaultFormDataArchiveQueryParams,
    DefaultAccountSortParams,
    DefaultAccountQueryParams,
    DefaultAccountTypeSortParams,
    DefaultAccountTypeQueryParams,
    DefaultTissueTypeQueryParams,
    DefaultTissueTypeSortParams,
    DefaultOfficeQueryParams,
    DefaultOfficeSortParams,
    DefaultRecoveryAppImportQueryParams,
    DefaultRecoveryAppImportSortParams,
    DefaultNotificationConfigSortParams,
    DefaultNotificationConfigQueryParams,
    DefaultCaseNoteQueryParams,
    DefaultCaseNoteSortParams,
    DefaultFormTypeQueryParams,
    DefaultFormTypeSortParams,
    DefaultPersonSortParams,
    DefaultPersonQueryParams,
    DefaultProcedureTypeQueryParams,
    DefaultProcedureTypeSortParams,
    DefaultShippingMethodQueryParams,
    DefaultShippingMethodSortParams,
    DefaultShippingStatusSortParams,
    DefaultShippingStatusQueryParams,
    DefaultOrderQueryParams,
    DefaultOrderSortParams,
    DefaultShipmentQueryParams,
    DefaultShipmentSortParams,
    DefaultCountrySortParams,
    DefaultCountryQueryParams,
    DefaultSurgerySchedulerSurgeonQueryParams,
    DefaultSurgerySchedulerSurgeonSortParams,
    DefaultTissueOfferSortParams,
    DefaultTissueOfferQueryParams,
    DefaultPersonTypeSortParams,
    DefaultPersonTypeQueryParams,
    DefaultFollowUpQueryParams,
    DefaultFollowUpSortParams,
    DefaultCaseFollowUpQueryParams,
    DefaultCaseFollowUpSortParams,
    DefaultInvoiceQueryParams,
    DefaultInvoiceSortParams,
    DefaultStandardFeeSortParams,
    DefaultStandardFeeQueryParams,
    DefaultAccountFeeSortParams,
    DefaultAccountFeeQueryParams,
    DefaultSurgeryQueryParams,
    DefaultSurgerySortParams,
    DefaultTissueQueryParams,
    DefaultTissueSortParams,
    DefaultChartReviewLogQueryParams,
    DefaultChartReviewLogSortParams,
    DefaultAccountCreditEntryQueryParams,
    DefaultAccountCreditEntrySortParams,
} from "../../models";

export const DefaultParams: IParams = {
    accounts: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAccountSortParams,
        queryParams: DefaultAccountQueryParams,
    },
    accountCreditEntries: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAccountCreditEntrySortParams,
        queryParams: DefaultAccountCreditEntryQueryParams,
    },
    accountFees: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAccountFeeSortParams,
        queryParams: DefaultAccountFeeQueryParams,
    },
    accountTypes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAccountTypeSortParams,
        queryParams: DefaultAccountTypeQueryParams,
    },
    auditLogCategories: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAuditLogCategorySortParams,
        queryParams: DefaultAuditLogCategoryQueryParams,
    },
    auditLogEntries: {
        pageParams: DefaultPageParams,
        sortParams: DefaultAuditLogEntrySortParams,
        queryParams: DefaultAuditLogEntryQueryParams,
    },
    callBacks: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCallBackSortParams,
        queryParams: DefaultCallBackQueryParams,
    },
    cases: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCaseSortParams,
        queryParams: DefaultCaseQueryParams,
    },
    caseFollowUps: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCaseFollowUpSortParams,
        queryParams: DefaultCaseFollowUpQueryParams,
    },
    caseNotes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCaseNoteSortParams,
        queryParams: DefaultCaseNoteQueryParams,
    },
    caseFileCategories: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCaseFileCategorySortParams,
        queryParams: DefaultCaseFileCategoryQueryParams,
    },
    chartReviewLogs: {
        pageParams: DefaultPageParams,
        sortParams: DefaultChartReviewLogSortParams,
        queryParams: DefaultChartReviewLogQueryParams,
    },
    countries: {
        pageParams: DefaultPageParams,
        sortParams: DefaultCountrySortParams,
        queryParams: DefaultCountryQueryParams,
    },
    followUps: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFollowUpSortParams,
        queryParams: DefaultFollowUpQueryParams,
    },
    forms: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormSortParams,
        queryParams: DefaultFormQueryParams,
    },
    formCategories: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormCategorySortParams,
        queryParams: DefaultFormCategoryQueryParams,
    },
    formSelectCategories: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormSelectCategorySortParams,
        queryParams: DefaultFormSelectCategoryQueryParams,
    },
    formData: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormDataSortParams,
        queryParams: DefaultFormDataQueryParams,
    },
    formDataArchives: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormDataArchiveSortParams,
        queryParams: DefaultFormDataArchiveQueryParams,
    },
    formSelects: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormSelectSortParams,
        queryParams: DefaultFormSelectQueryParams,
    },
    formTypes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultFormTypeSortParams,
        queryParams: DefaultFormTypeQueryParams,
    },
    invoices: {
        pageParams: DefaultPageParams,
        sortParams: DefaultInvoiceSortParams,
        queryParams: DefaultInvoiceQueryParams,
    },
    notificationConfigs: {
        pageParams: DefaultPageParams,
        sortParams: DefaultNotificationConfigSortParams,
        queryParams: DefaultNotificationConfigQueryParams,
    },
    offices: {
        pageParams: DefaultPageParams,
        sortParams: DefaultOfficeSortParams,
        queryParams: DefaultOfficeQueryParams,
    },
    orders: {
        pageParams: DefaultPageParams,
        sortParams: DefaultOrderSortParams,
        queryParams: DefaultOrderQueryParams,
    },
    person: {
        pageParams: DefaultPageParams,
        sortParams: DefaultPersonSortParams,
        queryParams: DefaultPersonQueryParams,
    },
    personTypes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultPersonTypeSortParams,
        queryParams: DefaultPersonTypeQueryParams,
    },
    procedureTypes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultProcedureTypeSortParams,
        queryParams: DefaultProcedureTypeQueryParams,
    },
    recoveryAppImports: {
        pageParams: DefaultPageParams,
        sortParams: DefaultRecoveryAppImportSortParams,
        queryParams: DefaultRecoveryAppImportQueryParams,
    },
    shipments: {
        pageParams: DefaultPageParams,
        sortParams: DefaultShipmentSortParams,
        queryParams: DefaultShipmentQueryParams,
    },
    shippingMethods: {
        pageParams: DefaultPageParams,
        sortParams: DefaultShippingMethodSortParams,
        queryParams: DefaultShippingMethodQueryParams,
    },
    standardFees: {
        pageParams: DefaultPageParams,
        sortParams: DefaultStandardFeeSortParams,
        queryParams: DefaultStandardFeeQueryParams,
    },
    surgeries: {
        pageParams: DefaultPageParams,
        sortParams: DefaultSurgerySortParams,
        queryParams: DefaultSurgeryQueryParams,
    },
    surgerySchedulerSurgeons: {
        pageParams: DefaultPageParams,
        sortParams: DefaultSurgerySchedulerSurgeonSortParams,
        queryParams: DefaultSurgerySchedulerSurgeonQueryParams,
    },
    shippingStatuses: {
        pageParams: DefaultPageParams,
        sortParams: DefaultShippingStatusSortParams,
        queryParams: DefaultShippingStatusQueryParams,
    },
    tenants: {
        pageParams: DefaultPageParams,
        sortParams: DefaultTenantSortParams,
        queryParams: DefaultTenantQueryParams,
    },
    tissues: {
        pageParams: DefaultPageParams,
        sortParams: DefaultTissueSortParams,
        queryParams: DefaultTissueQueryParams,
    },
    tissueOffers: {
        pageParams: DefaultPageParams,
        sortParams: DefaultTissueOfferSortParams,
        queryParams: DefaultTissueOfferQueryParams,
    },
    tissueTypes: {
        pageParams: DefaultPageParams,
        sortParams: DefaultTissueTypeSortParams,
        queryParams: DefaultTissueTypeQueryParams,
    },
    users: {
        pageParams: DefaultPageParams,
        sortParams: DefaultUserSortParams,
        queryParams: DefaultUserQueryParams,
    },
};
